// extracted by mini-css-extract-plugin
export default {"root":"zF9b_VTO434dxmErxCLE","icon":"Hj3pNfmks4Ak9jg2aC1_","text":"YsVWVJP1NTNprFXEJpT2","title":"taB_7p5TCA23bxtfNksp"};